
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { moneyFormat } from "@/utils/util";
import LineChart from "@/components/LineChart/index.vue";
import moment from "moment";
import DimensionSelect from "@/components/DimensionSelect/index.vue";
import SearchPopup from "./SearchPopup.vue";
import {
  getWorkbenchCoreData,
  getWorkbenchCoreDataChart,
  getWorkbenchCoreDataShop2,
  getWorkbenchCoreDataChartShop2,
} from "@/api/shouyin";
import { Getter } from "vuex-class";

@Component({
  components: { LineChart, DimensionSelect, SearchPopup },
})
export default class CoreDataDetail extends Vue {
  @Getter companyId!: string;
  @Getter isMultiStore!: boolean;
  @Getter multiStoreList!: Array<any>;
  params: Record<string, any> = {};
  paramsLine = {
    lineName: "销售笔数", // 折线名称
    xData: [], // x轴数据
    yData: [], // y轴数据
  };
  tabList = ["销售笔数", "实收金额", "销售金额", "退货金额"];
  dimension = "门店";
  activeTab = 0;
  showTotal = true;
  searchRes = null;

  totalData: any[] = [];

  listData = [
    {
      label: "销售笔数",
      value: "0",
      prop: "totalOrderCount",
      isMoney: false,
      color: "#FD8305",
    },
    {
      label: "实收金额",
      value: "0",
      prop: "totalSaleMoney",
      isMoney: true,
    },
    {
      label: "销售金额",
      value: "0",
      prop: "totalOrderMoney",
      isMoney: true,
    },
    {
      label: "退货金额",
      value: "0",
      prop: "totalReturnMoney",
      isMoney: true,
    },
  ];

  @Watch("params", { deep: true, immediate: true })
  onParamsChange() {
    this.getData();
  }

  async getTotalData() {
    let res: any;
    if (this.isMultiStore) {
      const params = {
        orderType: this.params.orderType,
        queryTimeBegin: this.params.queryTimeBegin,
        queryTimeEnd: this.params.queryTimeEnd,
        storeList: this.multiStoreList.map((item) => {
          return { storeId: item };
        }),
      };
      res = await getWorkbenchCoreDataShop2(params, true);
    } else {
      res = await getWorkbenchCoreData(this.params, true);
    }
    this.listData.forEach((item) => {
      const value = res.data[0]?.[item.prop] || "";
      if (item.isMoney) {
        const formatValue = `${moneyFormat(value, "")}`;
        item.value = formatValue === "--" ? "0.00" : formatValue;
      } else {
        item.value = value || "0";
      }
    });
  }
  async getChartData() {
    /**
     * storeId
    queryTimeBegin
    queryTimeEnd
    orderType
    queryType 1 24小时, 2 日期
     */
    const startTime = this.params.queryTimeBegin?.slice(0, 10) ?? "";
    const endTime = this.params.queryTimeEnd?.slice(0, 10) ?? "";
    let paramObj: any = {
      ...this.params,
      queryType: startTime === endTime ? 1 : 2,
    };
    let res: any;
    if (this.isMultiStore) {
      paramObj = {
        orderType: this.params.orderType,
        queryTimeBegin: this.params.queryTimeBegin,
        queryTimeEnd: this.params.queryTimeEnd,
        queryType: startTime === endTime ? 1 : 2,
        storeList: this.multiStoreList.map((item) => {
          return { storeId: item };
        }),
      };
      res = await getWorkbenchCoreDataChartShop2(paramObj, true);
    } else {
      res = await getWorkbenchCoreDataChart(paramObj, true);
    }
    this.totalData = res.data;
    const xkey = startTime === endTime ? "hour" : "date";
    this.paramsLine.xData = res.data.map(
      (item: any) => `${startTime === endTime ? `${item[xkey]}点` : item[xkey]}`
    );
    const ykey =
      this.listData.find((item) => item.label === this.paramsLine.lineName)
        ?.prop ?? "totalOrderCount";
    this.paramsLine.yData = this.totalData.map((item) => {
      return item[ykey] || 0;
    });
  }
  async getData() {
    if (!this.params.storeId && !this.multiStoreList.length) return;
    if (!this.params.queryTimeBegin) return;
    await Promise.all([this.getTotalData(), this.getChartData()]);
  }

  @Watch("activeTab")
  onChangeTabs() {
    this.paramsLine.lineName = this.tabList[Number(this.activeTab)];
    const ykey =
      this.listData.find((item) => item.label === this.paramsLine.lineName)
        ?.prop ?? "totalOrderCount";
    this.paramsLine.yData = this.totalData.map((item) => {
      return item[ykey] || 0;
    });
  }

  onDimensionConfirm(value: string, orderType: string) {
    this.dimension = value;
    // 设置参数
    this.params = {
      ...this.params,
      orderType: orderType,
    };
  }
  onSearchConfirm(res) {
    this.searchRes = res;
    const { starttime, endtime } = res;
    this.params = {
      ...this.params,
      queryTimeEnd: `${endtime} 23:59:59`,
      queryTimeBegin: `${starttime} 00:00:00`,
    };
  }
  mounted() {
    const pObj = {
      queryTimeEnd: `${moment().format("YYYY-MM-DD")} 23:59:59`,
      queryTimeBegin: `${moment().format("YYYY-MM-DD")} 00:00:00`,
      orderType: "1",
      storeId: this.companyId,
    };

    const queryObj = this.$route.query;

    if (!Object.keys(queryObj).length) {
      this.params = pObj;
      return;
    }

    if (queryObj.isWorkbench !== "1") {
      this.params = pObj;
      return;
    }
    console.log("this.$route.query ** ", queryObj);
    const paramsStr = window.localStorage.getItem("WorkbenchParams");
    if (paramsStr && paramsStr !== "") {
      const workbenchParams = JSON.parse(paramsStr);

      if (workbenchParams.searchRes) {
        const searchRes = workbenchParams.searchRes;

        pObj.queryTimeEnd = `${searchRes.endtime} 23:59:59`;
        pObj.queryTimeBegin = `${searchRes.starttime} 00:00:00`;
        this.searchRes = searchRes;
      }
      if (workbenchParams.dimension) {
        pObj.orderType = workbenchParams.dimension.orderType;
        this.dimension = workbenchParams.dimension.text;
      }
    }
    this.params = pObj;
  }
}
